import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { accountActions } from '../../action/AccountAction';
import { loginActions } from "../../action/loginAction";
import { commonClass } from "../../helpers/commonClass";
import { Helmet } from "react-helmet";
import TooltipNotes from "../../Tooltip/Tooltip";
import { gameActions } from "../../action/GameAction";

class Withdraws extends Component {
    constructor(props) {
        super(props);
        this.state = {
            amount: '',
            accountno: '',
            accountname: '',
            ifsccode: '',
            branchname: '',
            ErrorAmount: '',
            Erroraccountno: '',
            Erroraccountname: '',
            Errorifsccode: '',
            OpenWithdraw: false
        }
        this.props.getBalance(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey, this.props.user.Country_code);
        // this.props.Amountrestriction(this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
    }
    handleChange = (e) => {
        try {
            // Clear Error Message.
            this.SetEmpty()
            if (e.target.name == 'amount') {
                //if (e.target.value == '' || /^[0-9\b]+$/.test(e.target.value))
                if (e.target.value == '' || /^\d*\.?\d{0,2}$/.test(e.target.value))
                    this.setState({ [e.target.name]: e.target.value });
            }
            else if (e.target.name == 'branchname') {
                this.setState({ [e.target.name]: e.target.value.replace(/[^a-z]/gi, '').toUpperCase() });
            }
            else if (e.target.name == 'accountname') {
                if (e.target.value == '' || /^[a-zA-Z ]*$/.test(e.target.value))
                    this.setState({ [e.target.name]: e.target.value.toUpperCase() });
            }
            else if (e.target.name == 'ifsccode' || e.target.name == 'accountno') {
                if (e.target.value == '' || /^[a-zA-Z0-9_]+$/.test(e.target.value))
                    this.setState({ [e.target.name]: e.target.value.toUpperCase() });
            }
            else {
                this.setState({ [e.target.name]: e.target.value.toUpperCase() });
            }
        }
        catch (ex) { }
    }
    getRandomNumbers() {
        const typedArray = new Uint8Array(5);
        const randomValues = window.crypto.getRandomValues(typedArray);
        return randomValues.join('');
    }

    // btmWithdrawAmt = (e) => {
    //     e.preventDefault();
    //     if (this.state.amount) {
    //         if (parseInt(this.state.amount) < 2) {
    //             this.showMsg('lblMinWithdraw');
    //             return;
    //         }
    //         if (this.state.accountname) {
    //             if (this.state.accountno) {
    //                 if (this.state.ifsccode) {
    //                     if (this.props.user && this.props.user.emailID == "") {
    //                         this.showMsg(this.props.t('lblrequiremail'));
    //                         return;
    //                     }
    //                     else {
    //                         let reqdata = { "type_id": 1, "amount": parseInt(this.state.amount * 100), "pg_type_id": 1, "pg_txn_id": this.getRandomNumbers(), "pg_ref_id": this.getRandomNumbers(), "pg_data": this.props.user.mobileNo, "item_description": this.props.user.Player_name, "bank_name": this.state.accountname, "ac_number": this.state.accountno, "ifsc_code": this.state.ifsccode, "branch_name": this.state.branchname };
    //                         this.props.Cashoutmoney(reqdata, this.props.user.mobileNo, this.props.i18n.language, this.props.user.loginKey);
    //                         this.setState({
    //                             amount: '',
    //                             accountno: '',
    //                             accountname: '',
    //                             ifsccode: '',
    //                             branchname: ''
    //                         });
    //                     }
    //                 }
    //                 else {
    //                     this.showMsg(this.props.t('lblPleaseEnterifsc'));
    //                 }
    //             }
    //             else {
    //                 this.showMsg(this.props.t('lblPleaseEnterAc'));
    //             }
    //         }
    //         else {
    //             this.showMsg(this.props.t('lblPleaseEnterbankname'));
    //         }
    //     }
    //     else {
    //         this.showMsg(this.props.t('lblPleaseEnterAmnt'));
    //     }
    // }

    btmWithdrawAmt = (e) => {
        e.preventDefault();
        let validationflag = true;
        if (!this.state.amount) {
            this.showMsg('lblPleaseEnterAmnt', 1);
            validationflag = false;
        }
        if (parseInt(this.state.amount) < 50 && validationflag == true) {
            this.showMsg('lblMinWithdraw', 1);
            validationflag = false;
        }
        if (!this.state.accountname) {
            this.showMsg('lblPleaseEnterbankname', 2);
            validationflag = false;
        }
        if (!this.state.accountno) {
            this.showMsg('lblPleaseEnterAc', 3);
            validationflag = false;
        }
        if (!this.state.ifsccode) {
            this.showMsg('lblPleaseEnterifsc', 4);
            validationflag = false;
        }
        if (validationflag) {
            const reqdata = {
                type_id: 1,
                amount: parseInt(this.state.amount * 100),
                pg_type_id: 1,
                pg_txn_id: this.getRandomNumbers(),
                pg_ref_id: this.getRandomNumbers(),
                pg_data: this.props.user.mobileNo,
                item_description: this.props.user.Player_name,
                bank_name: this.state.accountname,
                ac_number: this.state.accountno,
                ifsc_code: this.state.ifsccode,
                branch_name: this.state.branchname
            };

            this.props.Cashoutmoney(
                reqdata,
                this.props.user.mobileNo,
                this.props.i18n.language,
                this.props.user.loginKey
            );
            // Clear the form
            this.setState({
                amount: '',
                accountno: '',
                accountname: '',
                ifsccode: '',
                branchname: ''
            });
        }
    }



    setErrorMessage = (flagNo, errorstring) => {
        switch (flagNo) {
            case 1:
                this.setState({ ErrorAmount: errorstring })
                break;
            case 2:
                this.setState({ Erroraccountname: errorstring })
                break;
            case 3:
                this.setState({ Erroraccountno: errorstring })
                break;
            case 4:
                this.setState({ Errorifsccode: errorstring })
                break;
            default:
                break;
        }
    }

    showMsg = (msg, flagNo) => {
        let errorstring = this.props.t(msg)
        if (flagNo > 0) {
            this.setErrorMessage(flagNo, errorstring)
        }
        else {
            this.props.alertError(errorstring);
        }
    }
    componentDidMount() {
        // localStorage.setItem('atabId', 4); this code is using in Account Component
    }

    SetEmpty = () => {
        this.setState({ ErrorAmount: "" })
        this.setState({ Erroraccountname: "" })
        this.setState({ Erroraccountno: "" })
        this.setState({ Errorifsccode: "" })
    }
    render() {
        const { t } = this.props;
        const { ErrorAmount, Erroraccountname, Erroraccountno, Errorifsccode } = this.state;
        let IsErrorAmount = ErrorAmount.length > 0;
        let IsErroraccountname = Erroraccountname.length > 0;
        let IsErroraccountno = Erroraccountno.length > 0;
        let IsErrorifsccode = Errorifsccode.length > 0;
        return (
            <>
                {
                    process.env.REACT_APP_MODE != "development" && <Helmet>
                        <title>Gulf Ticket : Withdraw</title>
                        <meta name="description" content="Gulf Ticket Withdraw" />
                    </Helmet>
                }
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-withdrawals.png" />{t('lblwithdrawls')}</h1>
                    {/* <div class="proChangePass" onClick={() => { this.props.UpdateJackpotFlag() }}>JackPot Winners</div> */}
                </div>
                <>
                    <div class="balance">
                        <div class="balanceCont withdrawCont">
                            <div class="balanceTxt">
                                <img src="./assets/img/icons/tot-winnings.png" />
                                {t('lblTotalWinners')}
                            </div>
                            <h2>{this.props.appvariables.currency} {commonClass.aedCrnyConvert(this.props.user.winbalance)}</h2>
                            <a onClick={() => { this.setState({ OpenWithdraw: true }) }} class={`${this.state.OpenWithdraw == false ? 'opacityRemove' : 'opacity'}`} >{t('lblwithdraw')}</a>
                        </div>
                    </div>

                    {this.state.OpenWithdraw && <div className="register myAccProfUpdate withdrawSec">
                        <div className="registerInr">
                            <form class="register-form" onSubmit={this.btmWithdrawAmt}>
                                {/* <div className="paymentWithdraw">
                                        <div className="paymentnum">
                                            <span><img src="./assets/img/icons/coins_01.webp" /></span>
                                        </div>
                                        <div className="paymentCards">
                                            <p>{t('lblTotalWinners')}</p>
                                        </div>
                                    </div>
                                    <div className="paymentinp">{this.props.appvariables.currency} {commonClass.aedCrnyConvert(this.props.user.winbalance)}</div> */}
                                {/*<div className="paymentWithdraw winningsSection">
                                         <div className="paymentnum">
                                            <span><img src="./assets/img/icons/pay_by_check.webp" /></span>
                                        </div> */}
                                <div className="formCont">
                                    <div class="formCont">
                                        <label>{t('lblAmt')} <sup>*</sup></label>
                                        <input type="text" className={`form-control ${IsErrorAmount ? "errorBorder" : ""}`} id="txtAmount" placeholder={`${t('lblAmt')}*`} maxLength={7} name="amount" value={this.state.amount} onChange={(e) => this.handleChange(e)} autoComplete="off" />
                                        {IsErrorAmount && <div class="errorTxt">{ErrorAmount}</div>}
                                        <p>{t('lblMinWithdrawAmt')}</p>
                                    </div>

                                    <div class="formCont">
                                        <label>{t('bankname')}<sup>*</sup></label>
                                        <input type="text" className={`form-control ${IsErroraccountname ? "errorBorder" : ""}`} id="accountname" placeholder={`${t('bankname')}*`} maxLength={20} name="accountname" value={this.state.accountname} onChange={(e) => this.handleChange(e)} autoComplete="off" />
                                        {IsErroraccountname && <div class="errorTxt">{Erroraccountname}</div>}
                                    </div>

                                    <div class="formCont">
                                        <label>{t('accountNo')}<sup>*</sup></label>
                                        <input type="text" className={`form-control ${IsErroraccountno ? "errorBorder" : ""}`} id="accountNo" placeholder={`${t('accountNo')}*`} maxLength={34} name="accountno" value={this.state.accountno} onChange={(e) => this.handleChange(e)} autoComplete="off" />
                                        {IsErroraccountno && <div class="errorTxt">{Erroraccountno}</div>}
                                    </div>

                                    <div class="formCont">
                                        <label>{t('ifcsecode')}<sup>*</sup></label>
                                        <input type="text" className={`form-control ${IsErrorifsccode ? "errorBorder" : ""}`} id="ifsccode" placeholder={`${t('ifcsecode')}*`} maxLength={20} name="ifsccode" value={this.state.ifsccode} onChange={(e) => this.handleChange(e)} autoComplete="off" />
                                        {IsErrorifsccode && <div class="errorTxt">{Errorifsccode}</div>}
                                    </div>
                                    <div class="formCont">
                                        <label>{t('branchname')}</label>
                                        <input type="text" className={`form-control ${false ? "errorBorder" : ""}`} id="branchname" placeholder={`${t('branchname')} / ${t('lblCountry')}`} maxLength={30} name="branchname" value={this.state.branchname} onChange={(e) => this.handleChange(e)} autoComplete="off" />
                                    </div>

                                    <div class="formCont updateBtn">
                                        <button className="btn2" type="submit">{t('lblwithdraw')}</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>}
                </>
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    const { Amtrestnotes } = state.gameReducer;
    return { user, appvariables, Amtrestnotes };

}
const mapActionToProps = {
    alertError: alertActions.error,
    Cashoutmoney: accountActions.Cashoutmoney,
    getBalance: loginActions.getBalance,
    // Amountrestriction: gameActions.Amountrestriction
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Withdraws))